export default __webpack_public_path__ + "static/media/doctor-png-29750.ffae290f.png";